import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData } from '@definitiv-packages/angular-dba-library';

import { DebitorModel, ObjektModelView, ProjectLanguage, ProjektPermissionService, ServiceModelView, ServiceService, ServiceViewService } from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateServiceComponent } from '../../dialogs/create-service/create-service.component';

@Component({
  selector: 'app-service-main-view',
  templateUrl: './service-main-view.component.html',
  styleUrls: ['./service-main-view.component.scss'],
  standalone: false
})
export class ServiceMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public serviceList: ServiceModelView[] = [];
  public selectedService: ServiceModelView | null = null;

  public debitorList: DebitorModel[] = [];
  public debitorFilteredList: DebitorModel[] = [];
  public selectedDebitor: DebitorModel = new DebitorModel();

  public columnsdefMain: DbaDataTableColumn<ServiceModelView, ProjectLanguage>[] = [
    { id: 'Bezeichnung', label: 'Bezeichnung' },
    { id: 'Strasse', label: 'Strasse' },
    { id: 'PLZ', label: 'PLZ', width: 100 },
    { id: 'Ort', label: 'Ort' },
    { id: 'LandName', label: 'Land' },
    { id: 'LaufzeitVon', label: 'LaufzeitVon', datatype: DbaMAtTableDatatypesEnum.Date, format: "dd.MM.yyyy", width: 120 },
    { id: 'LaufzeitBis', label: 'LaufzeitBis', datatype: DbaMAtTableDatatypesEnum.Date, format: "dd.MM.yyyy", width: 120 },
    { id: 'Intervall', label: 'Intervall' },
    { id:'Servicerythmus',label:'Rhythmus'}
  ];

  constructor(
    public permissionService: ProjektPermissionService,
    private serviceViewService: ServiceViewService,
    private serviceService: ServiceService,
    private dialog: MatDialog,
  ) { super(); }

  public async ngOnInit(): Promise<void> {
    try {
      this.loading = true;
      this.serviceList = await this.serviceViewService.getFilteredList();
    } finally {
      this.loading = false;
    }
  }

  public async OpenDialog(data: DialogData<ServiceModelView>): Promise<void> {
    if (!this.permissionService.serviceSchreiben) return;

    var service = await firstValueFrom(this.dialog.open(CreateServiceComponent, { data: data }).afterClosed());

    if (!service)
      return

    var changedservice = await this.serviceViewService.get(service.ServiceID)

    this.selectedService = null;

    if (data.mode == 'create' || data.mode == 'copy')
      this.serviceList.push(changedservice);
    else if (data.mode == 'edit') {
      var index = this.serviceList.findIndex(x => x.ServiceID == service.ServiceID);
      if (index != -1)
        this.serviceList[index] = changedservice;
    }

    this.selectedService = changedservice;
  }

  public debitorFilter = (list: ObjektModelView[], filter: DebitorModel): ObjektModelView[] => {
    if (filter.DebitorID == undefined || filter.DebitorID == 0)
      return list;
    else      
      return list.filter(x => x.DebitorID == filter.DebitorID);
  }

   public async deleteData(objektID : number): Promise<void> {
      this.loading = true;
      await this.serviceService.delete(objektID);
      this.serviceList =  await this.serviceViewService.getList();
      this.loading = false;
  }
}
